import { render, staticRenderFns } from "./TableRiskAppraisalEp2_3x3.vue?vue&type=template&id=588d9caf&scoped=true"
import script from "./TableRiskAppraisalEp2_3x3.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisalEp2_3x3.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisalEp2_3x3.vue?vue&type=style&index=0&id=588d9caf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588d9caf",
  null
  
)

export default component.exports